import InventaireStocksController from './inventaire.stocks.controller';
import Template from './inventaire.stocks.html';

export default {
	controller: InventaireStocksController,
	template: Template
};
